var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeartBox"},_vm._l((_vm.maxHearts),function(i){return _c('span',{key:i},[_c('i',{staticClass:"fa-heart",class:[ i <= _vm.currentHearts ? 'fas text-danger' : 'far text-secondary']})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }